export * from './card-detail';



// WEBPACK FOOTER //
// ./src/app/models/user/index.ts